import loadable from '@loadable/component'
import { EVEntry, EVPage } from '@uswitch/ev-core/react'
import { EVCOptionsProvider } from '@uswitch/ev-utils/context/provider'
import { useIncludes } from '@uswitch/ev-utils/context/selectors'
import { Type } from '@uswitch/spark'
import React from 'react'
import uuid from 'uuid/v1'

import BroadbandTable from '../broadband-table/broadband-table'
import Options from '../eevee/options-map'
import StickyHeader from '../header/sticky-header'
import DontHydrate from '../helpers/dont-hydrate'
import { ModalTrigger } from '../modal'
import { PostcodeModal, DealModal } from '../modal/premade'
import { usePageContext } from '~/contexts/page-context'
import { usePageContent } from '~/hooks/usePageContent'
import { isBBHomepage, isTvHomepage } from '~/utils/page'

import { homepageSchema } from './homepage-schema'
import styles from './intent.styles.module.css'
import productSchema from './product-schema'

const MetaData = loadable(() => import('../meta-data/meta-data'))
const IntentHero = loadable(() => import('../hero/wrappers/intent-hero'))
const PageContentTabs = loadable(() => import('./results/components/page-content-tabs'))

const Intent = ({ showDealsTable = true }) => {
  const { embeddedEeveeEntityIds, pageId, params, slug } = usePageContext()
  const includes = useIncludes()

  const isProviderPage = pageId.includes('providers')

  const { metaTitle, metaDescription, ...pageContent } = usePageContent()

  const getWebpageSchema = () => {
    if (isBBHomepage(pageId)) {
      return [homepageSchema(includes, embeddedEeveeEntityIds), productSchema(includes, embeddedEeveeEntityIds)]
    }

    return null
  }

  const currentMonth = new Date().toLocaleString('default', { month: 'long', year: 'numeric' })

  return (
    <div data-controller='homepage-scroll tracking' data-action='scroll@window->homepage-scroll#onScroll'>
      <MetaData metaTitle={metaTitle} metaDescription={metaDescription} webpageSchema={getWebpageSchema()} />

      <div className={styles.homepageHero}>
        <IntentHero>
          {embeddedEeveeEntityIds?.heroContent && (
            <EVCOptionsProvider value={Options}>
              <EVEntry id={embeddedEeveeEntityIds?.heroContent} />
            </EVCOptionsProvider>
          )}
        </IntentHero>
      </div>

      <PostcodeModal />
      <DealModal />

      <ModalTrigger id='postcode' data-trigger-source-id-param={uuid()} data-trigger-source-param='stickyHeaderModal'>
        <StickyHeader />
      </ModalTrigger>

      <DontHydrate>
        {showDealsTable && (
          <div className={styles.greyBackground}>
            <div className={styles.wrapper} data-is-homepage={isBBHomepage(pageId)}>
              {isBBHomepage(pageId) && (
                <Type.H4 as='h2' className='us-container'>
                  Some of our best broadband deals - {currentMonth}
                </Type.H4>
              )}
              <BroadbandTable
                address={{}}
                currentProvider=''
                adsVariables={{
                  adsFilters: {
                    allDeals: !!params['all-deals']
                  },
                  slug,
                  adsSortBy: 'RANK_ASC',
                  sjidVariant: 'test'
                }}
                filters={{}}
                sharedJourneyVariant='test'
                loading={false}
                onChangeFilters={() => {}}
                onChangeOrder={() => {}}
                order='RANK_ASC'
                postcode={null}
                providerPage={isProviderPage}
                nonServiceabilityPage
                setLoading={() => {}}
                showResultsSummary={!isBBHomepage(pageId)}
                criticalJs
                showSmallPrint={!isBBHomepage(pageId)}
                showAds={false}
                widelyAvailable={!isProviderPage && !isTvHomepage(pageId)}
              />
            </div>
          </div>
        )}

        {isBBHomepage(pageId) ? (
          <>{/* Return nothing for SSis to stitch in in place  */}</>
        ) : embeddedEeveeEntityIds?.modularPage ? (
          <EVPage id={embeddedEeveeEntityIds?.modularPage} />
        ) : (
          <PageContentTabs pageContent={pageContent} />
        )}
      </DontHydrate>
    </div>
  )
}

export default Intent
